import Image from './Image';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Image',
  ClassComponent: Image
});